let arrival_data6 = [
    {
        id : 20,
        imgurl : '/img/newarrival/section3_shoes5.jpg',
        brand : 'JILL BY JILLSTUART',
        title : '[에디]아이보리 나일론 로고패치 스트링 숄더백',
        persent : '12%',
        price : '98,000',
        saleprice : '86,240',
    },
    {
        id : 21,
        imgurl : '/img/newarrival/section3_shoes6.jpg',
        brand : 'COLE HAAN',
        title : '[ØRIGINALGRAND Saddle Golf] 진한 블루 남성 골프화',
        persent : '20%',
        price : '299,000',
        saleprice : '271,800',
    },
    {
        id : 22,
        imgurl : '/img/newarrival/section3_shoes7.jpg',
        brand : 'KERRIJADE',
        title : '스트랩 샌들_2 Color',
        persent : '5%',
        price : '238,000',
        saleprice : '226,100',
    },
    {
        id : 23,
        imgurl : '/img/newarrival/section3_shoes8.jpg',
        brand : 'House of plant.',
        title : 'cloud9 bracelet',
        persent : '14%',
        price : '110,000',
        saleprice : '89,800',
    },
]

export default arrival_data6